/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_BoldInputs */

const en_tables_rule_sets_bold = /** @type {(inputs: Tables_Rule_Sets_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Bold`)
};

const de_tables_rule_sets_bold = /** @type {(inputs: Tables_Rule_Sets_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Sets Bold" |
*
* @param {Tables_Rule_Sets_BoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_bold = /** @type {((inputs?: Tables_Rule_Sets_BoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_BoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_bold(inputs)
	return de_tables_rule_sets_bold(inputs)
});